module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "svi-household--dataset-cover.7a50ad8a.png";